module.exports = __webpack_public_path__ + "img/k18.dd893ff8.jpg";